export enum LiquibaseLogLevels {
  Off = 'off',
  Severe = 'severe',
  Warning = 'warning',
  Info = 'info',
  Debug = 'debug',
}
